module.exports = __webpack_public_path__ + "img/6.2ee1a173.png";